import { redirectFBReferrals } from './src/utils/functions';

// custom css
// import "typeface-montserrat";
// import "typeface-merriweather";
import "typeface-poppins";

// normalize CSS across browsers
import "./src/css/normalize.css";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

// custom CSS styles
import "./src/css/style.css";
import "./src/styles/grid.css";
import "./src/styles/btn.css";
import "./src/styles/style.css";



export const onClientEntry = () => {
    redirectFBReferrals();

    // Load Tolt referral tracking script
    if (typeof window !== 'undefined') {
        const toltScript = document.createElement('script');
        toltScript.src = 'https://cdn.tolt.io/tolt.js';
        toltScript.setAttribute('data-tolt', 'pk_7SJtbKd5PvrMdbBrKGM7B11r');
        toltScript.async = true;
        document.head.appendChild(toltScript);
    }
};